import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <p>&copy; {new Date().getFullYear()} Emperc. Todos os direitos reservados.</p>
                <p className="footer-links">
                    <a href="/sobre">Sobre</a> | <a href="/garantia">Garantia</a> | <a href="/clube-do-tecnico">Clube Técnico</a> | <a href="/termos-e-condicoes">Termos</a> | <a href="/privacidade">Privacidade</a>
                </p>
                <p className="footer-dev">
                    Desenvolvido por <a href="https://www.linkedin.com/in/marco-de-castro" target="_blank" rel="noopener noreferrer">Marco de Castro</a>
                </p>
            </div>
        </footer>
    );
};

export default Footer;
